<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        mounted() {

        },
        data() {
            return {}
        },
        methods: {},
        computed: {}
    }

</script>
